import { useCallback } from "react"

import { useNavigate } from "react-router-dom"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { ErrorBackground, ErrorBackgroundMobile } from "@l2r-front/l2r-icons"
import { useIsMobileDevice, useMediaQuery, useTheme } from "@l2r-front/l2r-ui"

import { I18N_NAMESPACE } from "../../constants/i18n"

import * as Styled from "./ErrorPage.styled"

export const ErrorPage = (props) => {

    const {
        resetError,
    } = props

    const { t } = useTranslation(I18N_NAMESPACE)
    const navigate = useNavigate()
    const reset = useCallback(() => {
        resetError()
        navigate("/")
    }, [navigate, resetError])

    const isMobile = useIsMobileDevice()
    const theme = useTheme()
    const isLargeScreen = useMediaQuery(theme.breakpoints.up("lg"))

    return <>
        {!isMobile && <Styled.AppBar
            id="app-bar"
            position="fixed"
            moduleTabs={null}
        >
            <Styled.Link to="/">
                {
                    isLargeScreen ? <Styled.Logo id="logiroad-logo" src={"assets/resources/logiroad-center-logo.svg"} />
                        : <Styled.SmallLogo id="logiroad-favicon" src={"assets/resources/Favicon_Logiroad.svg"} />
                }

            </Styled.Link>
            <Styled.NetworkSelector id="network-selector" />
        </Styled.AppBar>}
        <Styled.ErrorPageWrapper background={isMobile ? ErrorBackgroundMobile : ErrorBackground} isMobile={isMobile}>
            <Styled.MessageWrapper isMobile={isMobile}>
                <Styled.Message isMobile={isMobile} variant="Desktop & Mobile/Title big/Big bold desk.">
                    {t(I18N_NAMESPACE, "pages.error.message")}
                </Styled.Message>
                <Styled.Button isMobile={isMobile} onClick={reset} variant="tertiary">
                    {t(I18N_NAMESPACE, "pages.error.returnButton")}
                </Styled.Button>
            </Styled.MessageWrapper>
        </Styled.ErrorPageWrapper>
    </>
}